const roles = [
  {
    value: 'SUPER_ADMIN',
    label: 'Super Admin'
  },
  {
    value: 'MARKETING_SPV',
    label: 'Supervisor Marketing'
  },
  {
    value: 'LOGISTIC_ADMIN',
    label: 'Admin Logistik'
  },
  {
    value: 'FAA_ADMIN',
    label: 'Admin FAA'
  },
  {
    value: 'FAA_SPV',
    label: 'Supervisor FAA'
  },
  {
    value: 'MONITORING',
    label: 'Monitoring'
  },
  {
    value: 'ADMIN_POD',
    label: 'Admin POD'
  },
]

const allRoles = [
  {
    value: 'SUPER_ADMIN',
    label: 'Super Admin'
  },
  {
    value: 'MARKETING_SPV',
    label: 'Supervisor Marketing'
  },
  {
    value: 'LOGISTIC_ADMIN',
    label: 'Admin Logistik'
  },
  {
    value: 'FAA_ADMIN',
    label: 'Admin FAA'
  },
  {
    value: 'FAA_SPV',
    label: 'Supervisor FAA'
  },
  {
    value: 'MONITORING',
    label: 'Monitoring'
  },
  {
    value: 'ADMIN_POD',
    label: 'Admin POD'
  },
  {
    value: 'TRANSPORTER_SUPER_ADMIN',
    label: 'Transporter Super Admin'
  },
  {
    value: 'TRANSPORTER_ADMIN',
    label: 'Transporter Admin'
  },
  {
    value: 'TRANSPORTER_MONITORING',
    label: 'Transporter Monitoring'
  },
  {
    value: 'DRIVER',
    label: 'Sopir'
  },
  {
    value: 'SHIPPER_ADMIN',
    label: 'Shipper Admin'
  },
  {
    value: 'SHIPPER_SUPER_ADMIN',
    label: 'Shipper Super Admin'
  },
  {
    value: 'SHIPPER_MONITORING',
    label: 'Shipper Monitoring'
  },
]

const getRoleText = function (value) {
  console.log('TCL: getRoleText -> value', value)
  const role = allRoles.find(i => i.value === value)
  return (role && role.label) || ''
}

export default {
  userAdminDatabase: 'Database User Admin',
  edit: 'Ubah User Admin',
  create: 'Buat User Admin Baru',
  searchText: 'Cari Nama Admin',
  name: 'Nama',
  phone: 'No telepon',
  email: 'Email',
  role: 'Role',
  userAdminDeleteConfirmMsg: 'Apakah Anda yakin ingin menghapus akun ini?',
  userAdminDeleteSuccessMsg: 'Berhasil menghapus akun',
  resetPasswordButtonLabel: 'Reset Password',
  resetPasswordConfirmMsg: 'Apakah Anda yakin ingin me-reset password akun ini?',
  resetPasswordSuccessMsg: 'Berhasil me-reset password akun',
  roles,
  getRoleText,
}
